/**
 * ChartShell — wrapper for Recharts with consistent loading / empty states
 */
import React from 'react';
import { Loader2 } from 'lucide-react';

const ChartShell = ({ title, subtitle, loading, empty, height = 260, children }) => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
      {(title || subtitle) && (
        <div className="mb-4">
          {title   && <h3 className="text-sm font-semibold text-gray-900">{title}</h3>}
          {subtitle && <p className="text-xs text-gray-400 mt-0.5">{subtitle}</p>}
        </div>
      )}
      <div style={{ height }} className="w-full flex items-center justify-center">
        {loading ? (
          <Loader2 className="w-6 h-6 animate-spin text-gray-400" />
        ) : empty ? (
          <p className="text-sm text-gray-400">No data for this period</p>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export default ChartShell;
